import styled from 'styled-components';

import { ReactComponent as FeatherSend } from '../../../../assets/icons/Icon feather-send.svg'
import { ReactComponent as HourGlass } from '../../../../assets/icons/icon-hourglass.svg'
import { ReactComponent as CircularCheck } from '../../../../assets/icons/icon-circular-check.svg'

interface IStatusProps {
  status: number;
}

export const Docs = styled.div`
  margin-top: 26.4px;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 5px;

  .docs__documentation-button{
    width: 100%;
    height: 60px;
    margin-top: 10px;

    border-radius: 30px;
    text-align: center;
    vertical-align: middle;
    border: 0;
    font-size: 1.2rem;
    line-height: 60px;
    color: #fff;
    background-color: var(--blue2f);

    transition: all 0.5s ease-in-out;
    cursor: pointer;

    &:hover {
      filter: brightness(1.1);
    }
  }

  .file-input__label {
    margin-top: 10px;
  }
`;

export const IFeatherSend = styled(FeatherSend)`
  width: auto;
  height: 60%;
  margin: auto;

  stroke: var(--blue00);
`

export const IHourGlass = styled(HourGlass)`
  width: auto;
  height: 80%;
  margin: auto;

  fill: var(--blue00);

  > path {
    stroke: var(--blue00);
  }
`
export const ICircularCheck = styled(CircularCheck)`
  width: auto;
  height: 80%;
  margin: auto;

  fill: var(--blue00);
`

export const DocsProgress = styled.div<IStatusProps>`
  width: 338px;
  height: 185px;
  margin-top: 26.4px;
  padding: 31px 0 26px;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;

  border-radius: 22px;
  background-color: var(--bluef0);
  color: var(--blue00);

  .docs__title{
    width: 90%;
    margin: 0 auto;

    color: var(--blue00);
    font-size: 1.1875rem;
    font-weight: bold;
  }

  .docs__feedback{
    width: 90%;
    margin: -10px auto 0;

    color: var(--blue00);
    font-size: 0.875rem;
  }

  .docs__status-container{
    width: 85%;
    height: fit-content;
    margin: 0 auto;

    display: flex;
    justify-content: flex-start;
    gap: 40px;
    align-items: center;
  }

  .docs__status-step{
    width: 60px;
    height: 60px;

    display: flex;
    justify-content: center;
    align-items: center;
    flex: none;

    position: relative;

    border-radius: 50%;
    border: 3px solid var(--blue00);
  }

  ${({status}) => {
    if(status === 1){
      return `
        ${ICircularCheck}{
          fill: var(--blueb3);
        }

        .docs__status-step:last-of-type{
          border: 3px solid var(--blueb3);

          &::before{
            background-color: var(--blueb3) !important;
          }
        }
      `
    }
  }}

  .docs__status-step:not(:first-of-type)::before{
    content: " ";
    width: 40px;
    height: 5px;

    display: inline-block;

    position: absolute;
    right: calc(100% + 3px);

    background-color: var(--blue00);
  }

  @media (max-width: 455px){
    width: 100%;
  }
`;
